import {TokenExpirationHandlerInterface} from "@share/web-conferences/interfaces/TokenExpirationHandlerInterface";
import {JoinHandlerInterface} from "@share/web-conferences/interfaces/JoinHandlerInterface";

export class TokenExpirationHandler implements TokenExpirationHandlerInterface {
    private tokenIsRenewing = false;

    constructor(
        private readonly joinHandler: JoinHandlerInterface
    ) {
    }

    get isDisconnected(): boolean{
        return this.joinHandler.agora.client.connectionState == "DISCONNECTED";
    }

    subscribe(): void {
        this.joinHandler.agora.client.on('token-privilege-will-expire', async () => {
            console.log('%ctoken will expire', 'font-size: 30px');
            if (!this.tokenIsRenewing) {
                this.tokenIsRenewing = true;
                await this.renewToken();
                this.tokenIsRenewing = false;
            }
        });

        this.joinHandler.agora.client.on('token-privilege-did-expire', async () => {
            console.log('%ctoken expired', 'font-size: 30px');
            if (!this.tokenIsRenewing) {
                await this.renewToken();
            }
        })
    }

    /**
     * If the client is disconnected then calls join
     * else try to renew tokens
     */
    async renewToken() {
        if (this.isDisconnected) {
            await this.joinHandler.join();
            return;
        }

        await this.joinHandler.webConferenceService.join();
        if (this.joinHandler.webConferenceService.isWebConferenceDataNotEmpty()) {
            await this.joinHandler.agora.renewToken(this.joinHandler.webConferenceService.agoraCredentials?.token as string);
            this.joinHandler.shareClient.joined && await this.joinHandler.shareClient.client.renewToken(this.joinHandler.webConferenceService.agoraCredentials?.screenSharingToken as string);
        }
    }
}
